import { useState } from "react";
import { useTranslation } from "react-i18next";
import Banner from "./Banner";
import { IconExpandMore } from "cdk-radial";
import * as Styles from "./styles";
import { useAnalytics } from "../third-party-integration/amplitude";
import useCampaignStore from "./CampaignStore";
import {AMPLITUDE_EVENTS} from '../../constants';

import {useTheme} from '../theme/useTheme';

export default function BannerContainer() {
  const { campaigns } = useCampaignStore();
  const { darkMode } = useTheme() as any;
  const color = darkMode ? "#1A1A1A" : "#f2f2f2";
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(true);
  const {trackEvent} = useAnalytics();

  const expandOptions = () => {
    trackEvent(AMPLITUDE_EVENTS.CAMPAIGN_ACTIONS, {'Action': 'Expand'});
    setExpanded(true);
    closetColorHandler(color);
  };

  const hideBanner = () => {
    trackEvent(AMPLITUDE_EVENTS.CAMPAIGN_ACTIONS, {'Action': 'Hide',});
    setExpanded(false);
  };

  const closetColorHandler = (color: string) => {
    // TODO: based on PO applying this fix, this will be decided later based on UX and PO sync-up,
    // setClosetColor(color);
  };

  return (
    <>
      {campaigns && (
        <>
          <Styles.PromotionWrapperSpacer
            data-testid="banner-container"
            expanded={expanded}
          >
            <Styles.PromotionWrapper expanded={expanded}>
              {expanded && (
                <Styles.PromotionBanner darkMode={darkMode}>
                  <Styles.BannerBody>
                    <Banner
                      hideBanner={hideBanner}
                      closetColor={closetColorHandler}
                      bannerData={campaigns}
                    />
                  </Styles.BannerBody>
                </Styles.PromotionBanner>
              )}
            </Styles.PromotionWrapper>
          </Styles.PromotionWrapperSpacer>
            {!expanded && <Styles.GreetingWrapperSpacer expanded={expanded}>
              <Styles.GreetingWrapper expanded={expanded}>
                  <Styles.GreetingBody>
                      <Styles.BannerOptions
                          onClick={expandOptions}>
                          <div>{t('subHeader.discover')}</div>
                          <div><IconExpandMore tabIndex={0}
                              onKeyDown={(e: any) => {
                                  e.stopPropagation();
                                  if (e.key === 'Enter') {
                                      expandOptions()
                                  }
                              }} /></div>
                      </Styles.BannerOptions>
                  </Styles.GreetingBody>
              </Styles.GreetingWrapper>
            </Styles.GreetingWrapperSpacer>}
        </>
      )}
    </>
  );
}
